export default __webpack_public_path__ + "static/media/Trending.f29ab5c5.png";